import { browserTracingIntegration } from '@sentry/browser';
import { init as _init } from '@sentry/react';

import pkg from '@/../package.json' with { type: 'json' };
import config from '@/config';
import { env } from '@/env';

import { createSentryRelease } from './release';

function init() {
    return _init({
        dsn: config.sentry.dsn,
        debug: config.dev.sentryDebug,
        enabled: env.VITE_IS_SENTRY_ENABLED && !env.VITE_PLAYWRIGHT_RUN,
        environment: env.VITE_SENTRY_ENVIRONMENT,
        release: createSentryRelease({ demo: env.VITE_DEMO, saas: env.VITE_SAAS, version: pkg.version }),
        integrations: [browserTracingIntegration()],
    });
}

export function initSentry() {
    if (!env.VITE_IS_SENTRY_ENABLED) {
        return;
    }

    // eslint-disable-next-line compat/compat
    window.requestIdleCallback ? window.requestIdleCallback(init) : init();
}
